import { createStore } from 'jotai'

export const shotListStore = createStore()

export const projectsStore = createStore()

export const editorCommentStore = createStore()

export const videoEditorStore = createStore()

export const userCredits = createStore()
